import React, { Component } from 'react';

import Contact from 'assets/images/contact/contact.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class ContactView extends Component {
  render() {
    return (
      <div className="contentContainer contact">

        <div className="contactView__Header" />
        <div className="contacts">
          <div className="contactView">
            <div className="contactView__Content">
              <img className="headshot" src={Contact} alt="Beth" />
              <h1>Liliana Rivera</h1>
              <h2>Senior Director of Tourism | VisitDallas</h2>
              <p><FontAwesomeIcon icon={['fas', 'phone']} />+1 214 571 1351</p>
              <a href="mailto:liliana@visitdallas.com"><FontAwesomeIcon icon={['fas', 'envelope']} />Liliana@VisitDallas.com</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
